import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { VendorActions } from "../actions/vendor.actions";
import { VendorAchActions } from "../actions/vendor-ach.actions";
import { VendorState } from "../models/vendor-state";

const initialState: VendorState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(VendorActions.account.getApi, (state) => _.merge(_.cloneDeep(state), { loading: true })),
	on(VendorActions.account.getSuccess, (state, action) => _.omit(action, "type")),
	on(VendorActions.account.updateVendorAgreementSigningStatusSuccess, (state, vendorState) => {
		return {
			...state,
			loading: vendorState.loading,
			vendor: {
				...vendorState.vendor,
				achCommerceId: state.vendor?.achCommerceId || vendorState?.vendor?.achCommerceId
			}
		};
	}),
	on(VendorActions.account.getFail, (state, action) =>
		_.merge(_.cloneDeep(state), _.omit(action, "type"))
	),
	on(VendorAchActions.createAccount.createSuccess, (state, action) => ({
		...state,
		vendor: {
			...state.vendor,
			achCommerceId: action.achCommerceId
		}
	}))
);

export function vendorReducer(state: VendorState | undefined, action: Action): VendorState {
	return reducer(state, action);
}
